<!-- <h4 class="title">Follow up Save</h4> -->
<mat-icon style="text-align: right;width: 100%;margin-bottom: 13px;margin-top: -10px;" mat-button (click)="close()">close</mat-icon>

<div class="row">
    <div class="col-md-12">
        <!-- <h4 class="title-f">Settlement Recording</h4> -->
        <div class="card-box">
            <h4 class="title-f">Customer Details</h4>
            <div class="row" style="padding: 0px 0px 23px 10px;">
                <div class="col-md-3">
                    <h5 class="form-lable">Customer Availability:</h5>
                    <input type="text" pInputText placeholder="" value="NA" disabled>
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Customer Name:</h5>
                    <input type="text" pInputText placeholder="" value="Vignesh" disabled>
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Contact:</h5>
                    <input type="text" pInputText placeholder="" value="986547478" disabled>
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Emirates ID/Passport No:</h5>
                    <input type="text" pInputText placeholder="" value="NA" disabled>
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Address:</h5>
                    <input type="text" pInputText placeholder="" value="No:2 GV nagar,Chennai" disabled>
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Relationship <Noscript></Noscript>:</h5>
                    <input type="text" pInputText placeholder="" value="NA" disabled>
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Nationality</h5>
                    <input type="text" pInputText placeholder="" value="Indian" disabled>
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Reason for PLA:</h5>
                    <input type="text" pInputText placeholder="" value="NA" disabled>
                </div>
                <!-- <div class="col-md-3 mt-20">
                  <button type="button" class="btn btn-primary">Save</button>
             </div> -->

            </div>

            <h4 class="title-f">Liabilities</h4>
            <div class="row" style="padding: 0px 0px 23px 10px;">
                <div class="col-md-12" style="margin-top: 15px;">

                    <div class="doc-table">
                        <div class="card-box"> <p-table [value]="rows | filter:searchQR" styleClass="ui-table-customers" #tt
                            [paginator]="false" [rows]="5" [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]"
                            [showCurrentPageReport]="true"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                            [globalFilterFields]="['type']">
                            <ng-template pTemplate="header">
                                <tr style="text-align: center;">
                                    <th>Liability Type</th>
                                    <th>Liability Amt. </th>
                                    <th>AGR ID</th>
                                    <th>Acc No.</th>
                                    <th>CIF No.</th>
                                </tr>
                                <tr style="text-align: center;">
                                    <td><input type=""></td>
                                    <td><input type=""></td>
                                    <td><input type=""></td>
                                    <td><input type=""></td>
                                    <td><input type=""></td>
                                </tr>
                            </ng-template>
                         </p-table>  </div>
                    </div>
                </div>
            </div>


            <h4 class="title-f">Cheque Details</h4>
            <div class="row" style="padding: 0px 0px 23px 10px;">
                <div class="col-md-12" style="margin-top: 15px;">

                    <div class="doc-table">
                        <div class="card-box"> <p-table [value]="rows | filter:searchQR" styleClass="ui-table-customers" #tt
                            [paginator]="false" [rows]="5" [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]"
                            [showCurrentPageReport]="true"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                            [globalFilterFields]="['type']">
                            <ng-template pTemplate="header">
                                <tr style="text-align: center;">
                                    <th>Details</th>
                                    <th>Cheque No. </th>
                                    <th>Cheque Barcode No.</th>
                                    <th>Bank/Branch</th>
                                    <th>OPC/GOPS Dispatch Date</th>
                                    <th>OPC/GOPS Dispatch Ref No.</th>
                                    <th>Action</th>
                                    <th>Cheque Action Remarks</th>
                               
                                </tr>
                                <tr style="text-align: center;">
                                    <td><input type=""></td>
                                    <td><input type=""></td>
                                    <td><input type=""></td>
                                    <td><input type=""></td>
                                    <td><input type=""></td>
                                    <td><input type=""></td>
                                    <td><input type=""></td>
                                    <td><input type=""></td>
                                </tr>
                            </ng-template>
                         </p-table>  </div>

                    </div>
                    <div class="doc-table">
                        <div class="card-box"> <p-table [value]="rows | filter:searchQR" styleClass="ui-table-customers" #tt
                            [paginator]="false" [rows]="5" [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]"
                            [showCurrentPageReport]="true"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                            [globalFilterFields]="['type']">
                            <ng-template pTemplate="header">
                                <tr style="text-align: center;">
                                    <th>Chq. Date</th>
                                    <th>Chq. Amt </th>
                                    <th>Suspense Acc No.</th>
                                    <th>Chq. Status</th>
                                    <th>Date Posted</th>
                                    <th>Clearing Unit Dispatch Date</th>
                                    <th>Clearing Unit Dispatch No</th>
                               
                                </tr>
                                <tr style="text-align: center;">
                                    <td><input type=""></td>
                                    <td><input type=""></td>
                                    <td><input type=""></td>
                                    <td><input type=""></td>
                                    <td><input type=""></td>
                                    <td><input type=""></td>
                                    <td><input type=""></td>
                                </tr>
                            </ng-template>
                         </p-table>  </div>
                        
                    </div>
                </div>
            </div>

            <h4 class="title-f">Typing Details</h4>
            <div class="row" style="padding: 0px 0px 23px 10px;">
                <div class="col-md-12" style="margin-top: 15px;">

                    <div class="doc-table">
                        <div class="card-box"> <p-table [value]="rows | filter:searchQR" styleClass="ui-table-customers" #tt
                            [paginator]="false" [rows]="5" [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]"
                            [showCurrentPageReport]="true"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                            [globalFilterFields]="['type']">
                            <ng-template pTemplate="header">
                                <tr style="text-align: center;">
                                    <th>Returned chq. Status</th>
                                    <th>Submitted for typing</th>
                                    <th>Typing Processor</th>
                                    <th>Typing Status</th>
                                    <th>Field Collector</th>
                                    <th>Submitted for filling</th>
                               
                                </tr>
                                <tr style="text-align: center;">
                                    <td><input type=""></td>
                                    <td><input type=""></td>
                                    <td><input type=""></td>
                                    <td><input type=""></td>
                                    <td><input type=""></td>
                                    <td><input type=""></td>
                                </tr>
                            </ng-template>
                         </p-table>  </div>

                    </div>
                </div>
            </div>

            <h4 class="title-f">Case Details</h4>
            <div class="row" style="padding: 0px 0px 23px 10px;">
                <div class="col-md-12" style="margin-top: 15px;">

                    <div class="doc-table">
                        <div class="card-box"> <p-table [value]="rows | filter:searchQR" styleClass="ui-table-customers" #tt
                            [paginator]="false" [rows]="5" [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]"
                            [showCurrentPageReport]="true"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                            [globalFilterFields]="['type']">
                            <ng-template pTemplate="header">
                                <tr style="text-align: center;">
                                    <th>Case No.</th>
                                    <th>Case Status</th>
                                    <th>Police Station</th>
                                    <th>Police Stn. City</th>
                                    <th>Case filed on</th>
                                    <th>Collector Name</th>
                               
                                </tr>
                                <tr style="text-align: center;">
                                    <td><input type=""></td>
                                    <td><input type=""></td>
                                    <td><input type=""></td>
                                    <td><input type=""></td>
                                    <td><input type=""></td>
                                    <td><input type=""></td>
                                </tr>
                            </ng-template>
                         </p-table>  </div>

                    </div>
                </div>
            </div>

            <h4 class="title-f">CourtCase/Prosecution Details</h4>
            <div class="row" style="padding: 0px 0px 23px 10px;">
                <div class="col-md-12" style="margin-top: 15px;">

                    <div class="doc-table">
                        <div class="card-box"> <p-table [value]="rows | filter:searchQR" styleClass="ui-table-customers" #tt
                            [paginator]="false" [rows]="5" [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]"
                            [showCurrentPageReport]="true"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                            [globalFilterFields]="['type']">
                            <ng-template pTemplate="header">
                                <tr style="text-align: center;">
                                    <th>Legal Body</th>
                                    <th>Case Number</th>
                                    <th>Case Date</th>
                                    <th>Name of Legal Body</th>
                                  
                                </tr>
                                <tr style="text-align: center;">
                                    <td><input type=""></td>
                                    <td><input type=""></td>
                                    <td><input type=""></td>
                                    <td><input type=""></td>
                                </tr>
                            </ng-template>
                         </p-table>  </div>

                    </div>
                </div>
            </div>
            <h4 class="title-f">Remarks</h4>
            <div class="row" style="padding: 0px 0px 23px 10px;">
                <div class="col-md-8">
                    <input type="text" pInputText placeholder="">
                </div>
               
                <div class="col-md-4 mt-20 text-right">
                  <button type="button" class="btn btn-primary">Save</button>
                  <button type="button" class="btn btn-primary">Close</button>
            
                </div>

            </div>
        </div>
    </div>
</div>

